export enum PaymentMethods {
	P24 = 'p24',
	BLIK = 'blik',
	BLIK_NO_CODE = 'blik-no-code',
	CARD = 'card',
	TRANSFER = 'transfer',
	APPLEPAY = 'applepay',
	GOOGLE_PAY_NATIVE = 'google-pay-native',
}
